import type { TruncationMode } from '../../typography/text-ellipsis/TextEllipsis.js';
import { TRUNCATION_MODE } from '../core/constants.js';
import type { SankeyHoverState } from './types/sankey-hover.js';

export const DISPLAY_NAME = 'SankeyChart';

export const INITIAL_HOVER_STATE: SankeyHoverState = { hovered: undefined };

export const DEFAULT_TRUNCATION_MODE: TruncationMode = TRUNCATION_MODE.Middle;

/** d3-sankey node geometry defaults (visual tuning deferred). */
export const DEFAULT_NODE_WIDTH = 24;
export const DEFAULT_NODE_PADDING = 20;
export const LAYOUT_MARGIN = 4;

export const FALLBACK_NODE_COLOR = '#888888';
export const NODE_BORDER_RADIUS = 4;

export const INSIDE_LABEL_PADDING = 8;
export const INSIDE_LABEL_WIDTH_RATIO = 0.8;
export const MAX_SIDE_LABEL_WIDTH_RATIO = 0.2;

export const LINK_OPACITY_LIGHT = 0.4;
export const LINK_OPACITY_DARK = 0.5;
